export default __webpack_public_path__ + "static/media/apple_app-store.872eb41a.svg";